import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { QuerifyService } from '../services/querify.service';
import { Queries } from './graphql/queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./graphql/queries";
import * as i3 from "../services/querify.service";
var FormsApi = /** @class */ (function () {
    function FormsApi(apollo, queries, querify) {
        this.apollo = apollo;
        this.queries = queries;
        this.querify = querify;
    }
    FormsApi.prototype.search = function (query, options) {
        options = this.querify.transformOptions(query, options);
        return this.apollo
            .query({
            query: this.queries.formsPaginated(),
            variables: options
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['forms'];
        }));
    };
    FormsApi.prototype.searchOne = function (formsId) {
        return this.apollo
            .query({
            query: this.queries.searchForm(),
            variables: { id: formsId }
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['form'];
        }));
    };
    FormsApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FormsApi_Factory() { return new FormsApi(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.Queries), i0.ɵɵinject(i3.QuerifyService)); }, token: FormsApi, providedIn: "root" });
    return FormsApi;
}());
export { FormsApi };
